import { List, MagnifyingGlass, Sparkle } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { TokuroLogo } from "@/components/brand/TokuroLogo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ClientSwitcher } from "@/components/ClientSwitcher";
import { NotificationBell } from "@/components/NotificationBell";
import { UserMenu } from "@/components/UserMenu";

export function TopBar({ onOpenMobileNav, onOpenPalette, minimal = false }) {
  if (minimal) {
    return (
      <header className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-border bg-background/85 px-4 shadow-elev-sm backdrop-blur sm:px-6" data-testid="client-topbar">
        <Link to="/portal" className="flex shrink-0 items-center" aria-label="Tokuro.ai — A DAAKYI Platform · home">
          <TokuroLogo variant="dark" size="sm" showTagline={false} testId="topbar-brand-logo" />
        </Link>
        <span className="hidden h-5 w-px bg-border sm:block" aria-hidden="true" />
        <div className="hidden min-w-0 shrink sm:block"><Breadcrumbs /></div>
        <span className="ml-auto flex shrink-0 items-center gap-1.5 border border-accent-ai/30 bg-accent-ai/5 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-accent-ai">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-ai" aria-hidden="true" /> Client Portal
        </span>
        <NotificationBell />
        <UserMenu />
      </header>
    );
  }
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-2 border-b border-border bg-background/85 px-4 shadow-elev-sm backdrop-blur sm:gap-3 sm:px-6">
      {/* Left — mobile nav + breadcrumbs */}
      <button
        onClick={onOpenMobileNav}
        data-testid="mobile-menu-button"
        aria-label="Open navigation menu"
        className="shrink-0 text-foreground lg:hidden"
      >
        <List className="h-6 w-6" weight="bold" />
      </button>

      <div className="hidden shrink-0 lg:block">
        <Breadcrumbs />
      </div>

      <div className="shrink-0">
        <ClientSwitcher />
      </div>

      {/* Center — global search (fills the bar, scales down to an icon on mobile) */}
      <div className="flex min-w-0 flex-1 justify-center px-1 sm:px-3">
        <button
          onClick={onOpenPalette}
          data-testid="command-palette-trigger"
          aria-label="Open search (Command or Control + K)"
          className="group flex h-9 w-auto min-w-0 items-center gap-2 border border-border bg-surface px-3 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-foreground sm:w-full sm:max-w-lg"
        >
          <MagnifyingGlass className="h-4 w-4 shrink-0 transition-colors group-hover:text-primary" weight="bold" />
          <span className="hidden flex-1 truncate text-left sm:inline">Search clients, outputs, knowledge…</span>
          <kbd className="ml-auto hidden shrink-0 items-center gap-0.5 border border-border bg-background px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground sm:flex">⌘K</kbd>
        </button>
      </div>

      {/* Right — create, then alerts + account */}
      <div className="flex shrink-0 items-center gap-2">
        <Link
          to="/studio"
          data-testid="topbar-generate"
          className="hidden items-center gap-1.5 bg-accent-ai px-3 py-1.5 text-sm font-semibold text-accent-ai-foreground transition-all hover:ai-glow sm:flex"
        >
          <Sparkle className="h-4 w-4" weight="fill" />
          Generate
        </Link>

        <div className="mx-0.5 hidden h-6 w-px bg-border sm:block" aria-hidden="true" />

        <NotificationBell />
        <UserMenu />
      </div>
    </header>
  );
}
